import { useCallback } from "react";
import { InputControl } from "wvus-forms";

import { formatPrettyPhone } from "../../../helpers/fieldFormattingHelpers";
import { usePrepopulatedFieldValidation } from "../../../helpers/hooks/validatePrepopulatedField";

/**
 * TextInput component for rendering an input field with optional phone number formatting
 *
 * @param {Object} props.formMethods - Methods for handling form state and validation
 * @param {string} props.validationType - The type of validation to apply (e.g., 'phone')
 * @param {Object} props.fieldAttributes - The attributes for the input field such as fieldName, fieldValue, etc.
 *
 * @returns {JSX.Element} The rendered TextInput component.
 */
const TextInput = ({ formMethods, fieldAttributes, validationType }) => {
  const { fieldName, fieldValue } = fieldAttributes;
  const { getFormState } = formMethods;
  const formFields = getFormState().fields;

  usePrepopulatedFieldValidation(formMethods, fieldName, fieldValue);

  const phoneValueChange = useCallback(
    (e) => {
      const fieldValueRaw = `${e.target.value}`;
      const fieldValue = formatPrettyPhone(fieldValueRaw);

      formMethods.setValueChange(fieldName, fieldValue);
    },
    [fieldName, formMethods]
  );

  return (
    <>
      <InputControl
        {...fieldAttributes}
        formMethods={formMethods}
        fieldValue={fieldAttributes.fieldValue || formFields[fieldName]?.value}
        handleValueChange={validationType === "phone" ? phoneValueChange : undefined}
      />
      {fieldAttributes.descriptionText && (
        <p className="micro sub-text">{fieldAttributes.descriptionText}</p>
      )}
    </>
  );
};

export default TextInput;
